import React from "react";

function TrafficHomeOne({ className }) {
  return (
    <section className={`appie-service-area pt-140 pb-180 ${className || ""}`}>
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="appie-traffic-title">
              <h3 className="title">Chess Rules and Regulations</h3>
              <p>a. Common Rules</p>
              <p>• Common Draw for Men &amp; Women</p>
              <p>• Direct Knock-out</p>
              <p>
                • Touch-Move rule (once a player physically touches a piece
                ,they are obligated to move. If the touched piece does not have
                any legal square to move it will be considered as ILLEGAL move.
              </p>
              <p>
                • If an ILLEGAL move is made and noticed by the opponent, the
                opponent has the right to stop the clock and claim that an
                illegal move has been made.
              </p>
              <p>• ILLEGAL Moves</p>
              <p>• 1st ILLEGAL move will be considered as warning</p>
              <p>• 2nd ILLEGAL move will be considered as loss</p>
              <p>• Time Control: 5 Minutes on the clock</p>
              <p>
                • Pairing and choice of start will be done randomly. No personal
                preferences will be given.
              </p>
              <p>
                • Players are to download the <strong>'Chess Clock'</strong> app
                from Play Store.
              </p>
              <p>
                • The clock will be placed to the right hand side of the player
                with black pieces
              </p>
              <p>• You have to press the clock after every move you make</p>
              <p>
                • Use of mobile phones during the game is strictly prohibited
                (they will be only used as clocks)
              </p>
              <p>
                • Mobile phones of visitors and players are to be kept on
                Airplane mode with complete sound off and keep them charged.
              </p>
              <p>
                • No player is allowed to see/help the other player in a game by
                any means of verbal communication/gestures etc, if caught doing
                so the player will directly get eliminated.
              </p>
              <p>
                • Incase of discrepency the desicion made by the arbiter(refree)
                will be final and binding
              </p>
              <p>
                • Players are expected to adhere to a code of conduct, which
                includes maintaining sportsmanship, not distracting or
                interfering with opponents, and following the rules and
                regulations of the tournament.
              </p>
              <p>
                • Checkmate: When a player's king is in check, and there is no
                legal move to remove the king from check, it is checkmate. The
                game ends, and the player who checkmated the opponent wins.
              </p>
              <p>
                • Stalemate: If a player's king is not in check, but they have
                no legal moves left, it is a stalemate. The game ends in a draw.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default TrafficHomeOne;
